import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective } from '@jsverse/transloco';
import { TuiButton, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { of } from 'rxjs';
import { MediaPickerDialogInputs } from '../../models/media-picker-dialog-inputs';
import { MediaPickerSelection } from '../../models/media-picker-selection';
import { MediaPickerComponent } from '../media-picker/media-picker.component';

@Component({
  selector: 'pxc-media-picker-dialog',
  imports: [MediaPickerComponent, TranslocoDirective, TuiButton],
  templateUrl: './media-picker-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaPickerDialogComponent {
  protected readonly context =
    inject<TuiDialogContext<MediaPickerSelection | null, MediaPickerDialogInputs>>(POLYMORPHEUS_CONTEXT);

  protected readonly data = this.context.data;

  protected readonly groups = toSignal(this.data.groups$, { initialValue: [] });
  protected readonly hasMore = toSignal(this.data.hasMore$ ?? of(false), { initialValue: false });
  protected readonly isLoadingMore = toSignal(this.data.isLoadingMore$ ?? of(false), { initialValue: false });

  protected onConfirmed(selection: MediaPickerSelection): void {
    this.context.completeWith(selection);
  }

  protected onCancelled(): void {
    this.context.completeWith(null);
  }
}
